import {WebClient, AdminUpdateBuildPayload} from "../../store/clients/client";
import {Build, PromoteBuildByVersionRequest, PromoteBuildByVersionResponse} from "../../models/build";

export async function fetchBuildsPaginated(page:number) {
    try {
        const response = await WebClient.GetBuildList(page);

        if (response.status === 200) {
            return response.data['results'] as Build[]
        }
    }catch (e) {}

    return [] as Build[];
}

export async function createBuild(payload: Omit<Build, 'id' | 'created_at' | 'updated_at'>) {
    try {
        const response = await WebClient.AddBuild({
            ...payload,
            id: '',
            created_at: '',
            updated_at: '',
        });

        if (response.status === 200 || response.status === 201) {
            return response.data as Build;
        }
    } catch (e) {}

    return null;
}

export async function deleteBuild(id:string) {
    try {
        const response = await WebClient.DeleteBuild(id);

        if (response.status === 204) {
            return true;
        }
    }catch (e) {}

    return false;
}

export async function updateBuild(payload: AdminUpdateBuildPayload) {
    try {
        const response = await WebClient.AdminUpdateBuild(payload);
        if (response.status === 200) {
            return response.data as Build;
        }
    } catch (e) {}
    return null;
}

export async function adminPromoteBuild(build: Build) {
    try {
        const response = await WebClient.AdminPromoteBuild(build);

        if (response.status === 200) {
            return response.data as Build;
        }
    }catch (e) {}

    return {} as Build;
}

export async function adminPromoteBuildByVersion(request: PromoteBuildByVersionRequest) {
    try {
        const response = await WebClient.AdminPromotedBuildsByVersion(request);

        if (response.status === 200) {
            return response.data as PromoteBuildByVersionResponse;
        }
    }catch (e) {}

    return {} as PromoteBuildByVersionResponse;
}